import { h } from 'preact'
import { StateUpdater, useRef } from 'preact/hooks'
import { CurrencyValueForm } from 'models/apps'
import { sessionStorageService } from 'services/storage'
import { debounce } from 'utils/functions'

interface CalculatorInputProps {
  value: CurrencyValueForm
  setValue: StateUpdater<CurrencyValueForm>
}

const CalculatorInput = ({ value, setValue }: CalculatorInputProps) => {
  const isCheckValueCorrect = (inputValue: string): boolean => !['0', '0,', '', '0,00', '0,0'].includes(inputValue)

  const debouncedSetValue = useRef(
    debounce((inputValue: string) => {
      setValue({
        currentValue: inputValue,
        isValueCorrect: isCheckValueCorrect(inputValue),
      })
    }, 250),
  ).current

  const setInputValue = (inputValue: string): void => {
    debouncedSetValue(inputValue)
    sessionStorageService.setItem('preactCalculatorInputValue', inputValue)
  }

  const inputValidation = (event): void | string => {
    const value = (event.target as HTMLInputElement).value

    if (!value) {
      return ''
    }

    const transformedInput: string[] = value
      .toString()
      .replace(',', '.')
      .replace(/[^0-9.0-9{2}]+/g, '')
      .split('.')
      .slice(0, 2)

    if (transformedInput.length > 1 && !transformedInput[0]) {
      transformedInput[0] = '0'
    }

    if (transformedInput[1]) {
      transformedInput[1] = transformedInput[1].substr(0, 2)
    }

    if (transformedInput[0].startsWith('0') && transformedInput[0].length > 1) {
      transformedInput[0] = transformedInput[0].slice(1)
    }

    setInputValue(transformedInput.join(','))
  }

  return (
    <div className="hero-form__options-holder">
      <input
        className="hero-form__input-label"
        type="tel"
        value={value.currentValue}
        onInput={inputValidation}
        maxLength={6}
        aria-label="Kwota"
      />
    </div>
  )
}

export default CalculatorInput
